import * as React from 'react'
import { useEffect, useState, Suspense, useContext } from 'react'
import { useDebounce } from '../hooks/useDebounce'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { ACCENT_TEXT, setTitleFont, isEnter, goToElementId, ACCENT_TEXT_FW500, ACCENT_TEXT_FW700, tagger } from '../util/util'
import { ClusterCarousel } from '../components/clusterCarousel'
import { AppsTable } from '../components/appsTable'
import { DotLoader } from '../components/dotLoader'
import { HiveLoader } from '../components/hiveLoader'
import { ContactModal } from '../components/contactModal'
import { api } from '../api/api'
import '../css/contextDistanceCalculator.css'
import { useLocation } from 'react-router-dom'
import { CalculatorSearchParams } from '../util/CalculatorSearchParams'
import { AppContext } from '../app'

const WordVectors = React.lazy(() => import('../svg/wordVectors'))

const defaultTop20Data = [
    { 'name': 'Billion Cash Slots-Casino Game', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/86/2d/87/862d87f8-aeed-75c9-9d03-130d33f0077a/source/512x512bb.jpg', 'category': 'Casual', 'averageUserRating': 4.84503, 'confidence': 1, 'isDefault': true },
    { 'name': 'Eon Slots Casino Vegas Game', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/d5/09/de/d509de61-e28c-20c2-1367-bb3f10049dbc/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.58436, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Cash Tornado Slots - Casino', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/bd/78/16/bd7816ac-2a36-06ce-76bb-9dfa6876d4aa/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.90338, 'confidence': 0.5, 'isDefault': true },
    { 'name': 'Super Vegas Slots Casino Games', 'iconUrl': 'https://is5-ssl.mzstatic.com/image/thumb/Purple114/v4/c3/c7/83/c3c7831b-5c6a-9460-ee79-41c327ffffcc/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.67804, 'confidence': 0.44, 'isDefault': true },
    { 'name': 'Vegas Nights Slots', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/7f/9a/07/7f9a0791-40e8-56a2-cafc-85fb9553849c/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.70319, 'confidence': 0.4, 'isDefault': true },
    { 'name': 'Tycoon Casino - Vegas Slots', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple114/v4/7e/34/06/7e34063e-89fb-fc8b-403c-5f65dae4baa9/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.82416, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Winning Slots Las Vegas Casino', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/bf/e6/47/bfe64725-9c5a-3ba3-32fd-5d5dcd09e3f5/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.65444, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Cash Frenzy - Slots Casino', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/22/e8/0d/22e80df6-d861-9351-251a-d44f54766fc6/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.70422, 'confidence': 0.6, 'isDefault': true },
    { 'name': 'Vegas Slots - 7Heart Casino', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/e0/42/10/e0421050-83ec-0f32-2fe5-307cced54abe/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.86918, 'confidence': 0.1, 'isDefault': true },
    { 'name': 'Slots Casino - Vegas Slot Machine Games', 'iconUrl': 'https://is3-ssl.mzstatic.com/image/thumb/Purple111/v4/e1/4b/cf/e14bcf59-f889-a44d-1ba8-2c9ef0887f08/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.71264, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Epic Vegas Slots - Casino Game', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/10/e2/5c/10e25c37-c478-4e20-5e63-56bf95571d93/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.85238, 'confidence': 0.4, 'isDefault': true },
    { 'name': 'Slots of Vegas', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/e8/53/68/e85368c4-66db-0dd6-a3d1-7f55a8af8bc3/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.77894, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Slots: Vegas Casino Slot Games', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/fc/6b/a8/fc6ba843-b9f9-8e03-7590-5f36d5723523/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.73383, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Vegas Casino & Slots: Slottist', 'iconUrl': 'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/e4/89/e7/e489e76d-fcc3-f35c-55d7-62adb9bccbee/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.3375, 'confidence': 0.88, 'isDefault': true },
    { 'name': 'LuckyBomb Casino Slots', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/a4/48/e7/a448e796-c502-efce-48f8-6ce518079d95/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.03488, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Slots Mega Win Casino Game', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/b8/ce/17/b8ce17ae-f120-f6c4-0627-6d2e88904c21/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.42544, 'confidence': 0.75, 'isDefault': true },
    { 'name': 'High 5 Casino: Home of Slots', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/5c/44/4a/5c444a8d-fdb7-2a76-f856-3ce9cfd2725a/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.62333, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Winner Slots Casino Games', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/0c/0d/66/0c0d66fa-3c9f-91e5-7272-684c145b1c58/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.60511, 'confidence': 0.2, 'isDefault': true },
    { 'name': 'Cash Tap Casino: Slot Machines', 'iconUrl': 'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/ef/f0/47/eff04747-b777-2073-f637-c1fb0d8da877/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.62446, 'confidence': 0.9, 'isDefault': true }
]

const ContextDistanceCalculator = () => {
    const [searchQuery, setSearchQuery] = useState('')
    const [errorsSearchQuery, setErrorsSearchQuery] = useState([])
    const [isSearching, setIsSearching] = useState(false)
    const [nextSearchNumber, setNextSearchNumber] = useState(0)
    const [isCalculating, setIsCalculating] = useState(false)
    const [isListReady, setIsListReady] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [appNotFound, setAppNotFound] = useState(false)
    const [firstCalcDone, setFirstCalcDone] = useState(false)
    const [app, setApp] = useState<any>({})
    const [fakeData, setFakeData] = useState<any[]>([])

    const { t, i18n } = useTranslation('contextDistanceCalculator')
    const tCommon = useTranslation('common').t

    const location = useLocation()

    useEffect(() => {
        setTitleFont(i18n.language)
        setFakeData(defaultTop20Data)
        const bundle = new URLSearchParams(location.search).get('bundle')
        if (bundle) setSearchQuery(bundle)
    }, [])

    const scrollToApps = () => goToElementId('apps', true)
    const scrollToMethodology = () => goToElementId('word2vec', true)
    const scrollToTop = () => goToElementId('context-distance-calculator', true)

    const updateErrors = (err) => {
        setErrorsSearchQuery(err)
    }
    
    const {utmParameters} = useContext(AppContext)

    const getCalculatorSearchParams = (): CalculatorSearchParams => {
        const result: CalculatorSearchParams = {}

        if (utmParameters.utm_campaign) {
            result.utmCampaign = utmParameters.utm_campaign
        }
        if (utmParameters.utm_source) {
            result.utmSource = utmParameters.utm_source
        }
        if (utmParameters.utm_medium) {
            result.utmMedium = utmParameters.utm_medium
        }
        if (utmParameters.url) {
            result.url = utmParameters.url
        }

        return result
    }

    const startCalculating = async () => {
        setIsListReady(false)

        if (!searchQuery) {
            updateErrors([tCommon('required field')])
        }

        if (!app.name || appNotFound) {
            return
        }

        scrollToApps()
        setIsCalculating(true)

        try {
            const top20AppsList = await api.runCalculating(searchQuery, getCalculatorSearchParams())
            if (!top20AppsList.length) {
                setIsCalculating(false)
                return
            }
            setFakeData(top20AppsList)
            setFirstCalcDone(true)
        } catch (err) {
            setAppNotFound(true)
        }

        setIsCalculating(false)
        setIsListReady(true)
    }

    useEffect(() => {
        if (firstCalcDone) return
        const bundle = new URLSearchParams(location.search).get('bundle')
        if (bundle === searchQuery) startCalculating()
    }, [app])

    // used in search() to get last state of nextSearchNumber
    // search() can't get last state by itself because of closure
    const getNextSearchNumber = () => {
        let currentNextSearchNumber
        setNextSearchNumber(a => {
            currentNextSearchNumber = a
            return a
        })
        return currentNextSearchNumber
    }

    const search = async () => {
        const thisSearchNumber = nextSearchNumber
        setNextSearchNumber(thisSearchNumber + 1)
        setAppNotFound(false)
        updateErrors([])
        setIsSearching(true)
        setApp({})

        if (searchQuery) {
            try {
                const foundApp = await api.appStoreApp(searchQuery, getCalculatorSearchParams())

                // searches are asynchronous, so they can run in parallel
                // we check that it is the last search to set last searched app
                const nextSearchNumber = getNextSearchNumber()
                if (thisSearchNumber < nextSearchNumber - 1) {
                    return
                }

                if (foundApp && foundApp.name) {
                    setApp(foundApp)
                } else {
                    setAppNotFound(true)
                }
            } catch (err) {
                setAppNotFound(true)
            }
        } else {
            updateErrors([tCommon('required field')])
        }
        setIsSearching(false)
    }

    const debouncedSearchQuery = useDebounce(searchQuery, 500)

    useEffect(() => {
        if (debouncedSearchQuery) search()
    }, [debouncedSearchQuery])

    const toggleModal = () => setShowModal(!showModal)

    return (
        <div className="context-distance-calculator" id="context-distance-calculator">
            <ContactModal show={showModal} toggle={toggleModal} />
            <Helmet>
                <title>Context Distance Calculator</title>
                <meta name="title" content="" />
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <meta property="og:image" content="https://static.persona.ly/images/context_distance_calculator/open-graph.webp" />
            </Helmet>
            <div className="context-distance-calculator__content">
                <h1 className="title muli">{tagger(t('Context Calculator'), ACCENT_TEXT)}</h1>
                <div className="context-distance-calculator-header">
                    <div className="context-distance-calculator-header__description">
                        <p>{tagger(t('With the upcoming'), ACCENT_TEXT_FW700, 'https://persona.ly/glossary/attribution/user-acquisition-and-retargeting-in-ios-14')}</p>
                        <p>{tagger(t('To gain information'), ACCENT_TEXT)}</p>
                        <p>{tagger(t('To highlight'), ACCENT_TEXT)}</p>
                    </div>
                    <div className="context-distance-calculator-header__search-box">
                        <span className="context-distance-calculator__section-title">
                            {tagger(t('Find Contextually'), ACCENT_TEXT)}
                        </span>
                        <div className="contact-input-container">
                            <input value={searchQuery} className={'contact-input small-text' + (errorsSearchQuery.length > 0 ? ' error-input' : '')} type="text" name="searchQuery" placeholder={t('Enter a bundle')}
                                onChange={e => setSearchQuery(e.currentTarget.value)} onKeyPress={e => isEnter(e) && search()}
                            />
                        </div>
                        {errorsSearchQuery && errorsSearchQuery.map(err => <div className="error-small" key={err}>{err}</div>)}
                        <div className="context-distance-calculator-header__app">
                            <div className="context-distance-calculator-header__app-image-placeholder">
                                {isSearching ?
                                    <DotLoader /> :
                                    <img className={app.iconUrl ? 'app-image' : ''} src={app.iconUrl || 'https://static.persona.ly/images/context_distance_calculator/app-store-line.svg'} />
                                }
                            </div>
                            <div className="context-distance-calculator-header__app-info">
                                {!appNotFound ? (
                                    <>
                                        <span className="context-distance-calculator-header__app-main-text context-distance-calculator-header__app-name">{app.name || t('App name')}</span>
                                        <span className="context-distance-calculator-header__app-category">{app.categories && app.categories.slice(0, 3).join(', ') || t('Category')}</span>
                                    </>
                                ) : (
                                        <span className="context-distance-calculator-header__app-main-text context-distance-calculator-header__app-not-found">{t('Enter Valid ID')}</span>
                                    )}
                            </div>
                        </div>
                        <button onClick={() => startCalculating()} className="button-blue large">{t('Calculate')}</button>
                    </div>

                </div>
                <section id="apps" className="apps-list">
                    <span className="context-distance-calculator__section-title">
                        {tagger(t('Top apps'), ACCENT_TEXT)}
                    </span>
                    <div className="apps-list__content">
                        <div className={`apps-list__tables apps-list__tables--gradient ${isListReady ? '' : 'apps-list__tables--blur'}`}>
                            <div className="apps-list__table apps-list__table--left">
                                <AppsTable addToIndex={1} data={fakeData.slice(0, 10)} />
                            </div>
                            <div className="apps-list__table apps-list__table--right">
                                <AppsTable addToIndex={11} data={fakeData.slice(10, 20)} />
                            </div>
                        </div>
                        {
                            isCalculating ?
                                (
                                    <div className="results-box--loading results-box">
                                        <div>
                                            <HiveLoader />
                                            <span className="results-box__header">
                                                {t('Calculating Cosine')}
                                            </span>
                                        </div>
                                    </div>
                                ) :
                                (
                                    (isListReady && !appNotFound) || firstCalcDone ?
                                        (
                                            <div className="results-box results-box--cta">
                                                <div>
                                                    <span className="results-box__header">
                                                        {t('Ready to start?')}
                                                    </span>
                                                    <span className="results-box__text">
                                                        {tagger(t('Run effective'), ACCENT_TEXT_FW500)}
                                                    </span>
                                                    <div className="results-box__buttons">
                                                        <button onClick={scrollToMethodology} className="button-grey large">{tagger(t('Our methodology'), ACCENT_TEXT)}</button>
                                                        <button onClick={toggleModal} className="button-blue large">{tCommon('Start Now')}<img src="https://static.persona.ly/images/arrow.svg" /></button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) :
                                        (
                                            <div className="results-box">
                                                <div>
                                                    <span className="results-box__header">
                                                        {appNotFound ? tagger(t('No App Found Title'), 'no-wrap') : t('Bundle results')}
                                                    </span>
                                                    <span className="results-box__text">
                                                        {appNotFound ? t('No App Found Description') : t('Enter a bundle id and calculate')}
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                )
                        }
                    </div>
                </section>
                <section className="word2vec" id="word2vec">
                    <div className="word2vec__description">
                        <h2>{tagger(t('Why Word2Vec'), ACCENT_TEXT)}</h2>
                        <p>{tagger(t('When engineered'), ACCENT_TEXT)}</p>
                        <p>{tagger(t('Notions rendered'), ACCENT_TEXT)}</p>
                        <p>{tagger(t('Considering the production'), ACCENT_TEXT)}</p>
                        <p>{tagger(t('After the Word2Vec'), ACCENT_TEXT)}</p>
                    </div>
                    <div className="word2vec__clusters">
                        <p className="word2vec__clusters-description">
                            {t('An example of')}
                        </p>
                        <ClusterCarousel />
                    </div>
                </section>
                <section className="vectors">
                    <Suspense fallback={<div />}>
                        <WordVectors />
                    </Suspense>
                    <span className="vectors__description">
                        {t('A depiction of')}
                    </span>
                </section>
                <section id="representation" className="representation">
                    <h2>{tagger(t('Bundle vector'), ACCENT_TEXT)}</h2>
                    <p>{tagger(t('After generating'), ACCENT_TEXT)}</p>
                    <p>{tagger(t('This step'), ACCENT_TEXT)}</p>
                    <p>{tagger(t('After extensive testing'), ACCENT_TEXT)}</p>
                    <p>{tagger(t('Eventually our bundle'), ACCENT_TEXT)}</p>
                </section>
                <section id="ready-to-start" className="ready-to-start">
                    <div className="footer-t muli">
                        {t('Ready to start?')}
                    </div>
                    <div className="footer-d">
                        {tagger(t('Run effective'), ACCENT_TEXT_FW700)}
                    </div>
                    <div className="results-box__buttons">
                        <button onClick={scrollToTop} className="button-grey large">{tagger(t('Calculate context'), ACCENT_TEXT)}</button>
                        <button onClick={toggleModal} className="button-blue large">{tCommon('Start Now')}<img src="https://static.persona.ly/images/arrow.svg" /></button>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default ContextDistanceCalculator



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/contextDistanceCalculator.tsx